<nav class="nav nav-secondary mixed-loyalty-nav shadow mt-0">
  <a
    class="nav-item"
    [routerLink]="['/rewards']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'rewards.nav.marketplace.screenreader' | translate : { fgbdefault: 'Move to Marketplace page' } }}"
  >
    <label class="text-uppercase">{{ 'rewards.nav.marketplace' | translate }}</label>
  </a>
  <a
    class="nav-item"
    [routerLink]="['/rewards/events']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'rewards.nav.events.screenreader' | translate }}"
  >
    <label class="text-uppercase">{{ 'rewards.nav.events' | translate : { fgbdefault: 'Move to Events page' } }}</label>
  </a>
  <a
    class="nav-item"
    [routerLink]="['/rewards/raffles']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'rewards.nav.raffles.screenreader' | translate : { fgbdefault: 'Move to Raffles page' } }}"
  >
    <label class="text-uppercase">{{ 'rewards.nav.lotto' | translate }}</label>
  </a>

  <a
    class="nav-item d-none d-lg-block"
    [routerLink]="['/rewards/wallet']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'rewards.nav.wallet.screenreader' | translate : { fgbdefault: 'Move to Wallet page' } }}"
  >
    <label class="text-uppercase">{{ 'rewards.nav.wallet' | translate }}</label>
  </a>
</nav>
